import React, {useContext} from "react";
import {Col, Collapse, Row, Typography} from "@bezlimit/bezlimit-ui";
import {DownOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {LayoutContext} from "../../../core/Contexts";

export const LotteryAwards = ({awards}: IProps): JSX.Element => {
    const {t} = useTranslation();
    const contextLayout = useContext(LayoutContext);
    const colCount = _.gte(contextLayout?.width ?? 0, 768) ? 3 : 2;
    const {Panel} = Collapse;

    const grouppedAwards = 
        _.chain(awards)
            .groupBy("name")
            .map((i, k) => {
                const arr = i.map(item => item.position);
                const arrRange = arr.length > 1 ? `${arr[0]} - ${arr[arr.length - 1]}` : `${arr?.[0] ?? ''}`
                return {
                    positions: arrRange,
                    name: k
                };
            })
            .valueOf();

    const len = grouppedAwards.length;
    const size = len % colCount === 0 ? len/colCount : Math.floor(len/colCount) + 1;
    let awardsThreeCol = [];
    for (let i = 0; i < Math.ceil(grouppedAwards.length/size); i++){
        awardsThreeCol[i] = grouppedAwards.slice((i*size), (i*size) + size);
    }

    return (
        <Collapse
            ghost
            className="lottery-collapse"
            expandIconPosition="end"
            expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
        >
            <Panel header={t("Список призов")} key="1">
                <Row gutter={8}>
                    {(awardsThreeCol || []).map((item, ind) => (
                        <Col key={ind} span={24/colCount}>
                            <Row gutter={[8, 24]}>
                                {(item || []).map(i => (
                                    <Col key={i.name} span={24}>
                                        <Typography className="award-position">{
                                            t(`${i.positions} место`)}
                                        </Typography>
                                        <Typography className="award-name gold">
                                            {t(`${i.name}`)}
                                        </Typography>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    ))}
                </Row>
            </Panel>
        </Collapse>
    );
}

interface IAward {
    position: number;
    name: string;
}

interface IProps {
    awards: IAward[];
}